import { apiGet } from '../../utilities/apiClient';
import { getSessionIds } from './_sessionIds';
import {
  ADD_DOCUMENTS,
  FETCHING_DOCUMENTS,
  FETCHED_DOCUMENTS,
  UPDATE_PROJECT,
} from '../constants';

export const fetchDocuments = (projectId: number | string) => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId || projectId == null) return;
  dispatch({ type: FETCHING_DOCUMENTS, payload: true });
  try {
    const res = await apiGet(`/documents/get-all/${projectId}/${accountId}/${cognitoId}`);
    const data = res?.payload ?? res?.data ?? res;
    const list = Array.isArray(data) ? data : [];
    dispatch({ type: ADD_DOCUMENTS, payload: { project_id: String(projectId), list } });
    dispatch({ type: FETCHED_DOCUMENTS, payload: { project_id: String(projectId) } });
    dispatch({ type: UPDATE_PROJECT, payload: { id: projectId, document_count: list.length } });
  } catch {
    dispatch({ type: ADD_DOCUMENTS, payload: { project_id: String(projectId), list: [] } });
    dispatch({ type: FETCHED_DOCUMENTS, payload: { project_id: String(projectId) } });
  } finally {
    dispatch({ type: FETCHING_DOCUMENTS, payload: false });
  }
};
